<template>
  <div>
    <header v-if="isAuthenticated" class="header bg-primary">
      <img class="header__logo" src="/images/logo-mobile.png" alt="Resources Manager Logo">
      <h1 class="header__title">
        RESOURCES MANAGER 
      </h1>
      <span v-if="isGodMode" class="font-weight-light gl-title text-white">
        &nbsp;&nbsp;&nbsp;*** ojo ! GOD MODE ***
      </span>
      <button class="header__logout" type="button" aria-label="Logout" @click="logout">
        <v-icon size="x-large">
          mdi-power-settings
        </v-icon>
      </button>
    </header>
    <main class="main">
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState({
      isAuthenticated: (state) => state.user.isAuthenticated,
      isGodMode: (state) => state.global.isGod,
    }),
  },
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.goToLogin();
      });
    },
    goToLogin() {
      this.$router.push({ name: 'login' });
    },
  },
};
</script>
<style lang="scss">
@import './scss/main.scss';
</style>

<style src="vuetify/dist/vuetify.min.css"></style>
<style scoped lang="scss">
.header {
  top: 0px;
  z-index: 1004;
  transform: translateY(0px);
  position: fixed;
  left: 0px;
  width: 100%;
  box-shadow: 0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12);
  display: flex;
  align-items: center;
  padding: 4px 16px;

  &__logout {
    margin-left: auto;
  }

  &__title {
    margin-left: 8px;
    font-weight: 300;
    font-size: 24px;
  }
}

.main {
  flex: 1 0 auto;
  max-width: 95%;
  margin: 0 auto;
  padding: 64px 0 0 0;
  transition: .2s cubic-bezier(.4,0,.2,1);
}
</style>
